import React from 'react';

import Icon from '../icon2';

import './icon2__arrow-left.scss';

export default function Icon2ArrowLeft(props) {
    return (
        <Icon name="arrow-left" viewBox="0 0 45 24" {...props}>
            <path d="M0 12L12.12 0v9.944H45v4.112H12.12V24z" fillRule="nonzero" />
        </Icon>
    );
}
/* eslint-enable max-len */
